import axios from 'axios';
import { FeedGraph } from '../types/feed-graph.type';
import { GetFeedGraphInput } from '../types/get-feed-graph-input.type';

//POST
// /ewosapi/v1/planandprognosis/${globalCompanyId}graph/sites/totalfeed
// get total feed for a list of sites belonging to one company
export const getFeedGraph = async (
  globalCompanyId: string,
  request: GetFeedGraphInput,
  periodType: number = 1
): Promise<FeedGraph> => {
  const res = await axios.post<FeedGraph>(
    `/ewosapi/v1/planandprognosis/graph/company/${globalCompanyId}/sites/totalfeed?periodType=${periodType}`,
    request
  );
  return res.data;
};
